import { useEffect } from 'react';
import { Country } from 'helpers/internationalisation/classes/country';
const domains = [
    'https://gnmtouchpoint--dev1--c.cs88.visual.force.com',
    'https://gnmtouchpoint--c.eu31.visual.force.com',
];
const isSalesforceDomain = (domain) => !!domains.find((element) => element === domain);
const parseCustomerData = (data) => {
    const salesforceData = JSON.parse(data);
    const isoCountry = Country.findIsoCountry(salesforceData.customer.country);
    const { salutation, ...otherData } = salesforceData.customer;
    const customer = {
        ...otherData,
        title: salutation,
        country: isoCountry ?? undefined,
    };
    return {
        csr: salesforceData.csr,
        customer: customer,
        caseId: salesforceData.caseId,
    };
};
const useCsrCustomerData = (callback) => {
    useEffect(() => {
        function checkForParentMessage(event) {
            if (isSalesforceDomain(event.origin)) {
                callback(parseCustomerData(event.data));
            }
        }
        window.addEventListener('message', checkForParentMessage);
        return () => window.removeEventListener('message', checkForParentMessage);
    }, []);
};
const csrUserName = (csrCustomerData) => `${csrCustomerData.csr.firstName} ${csrCustomerData.csr.lastName}`;
export { useCsrCustomerData, csrUserName, parseCustomerData };
